import script from "./AddTextForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTextForm.vue?vue&type=script&setup=true&lang=js"

import "./AddTextForm.vue?vue&type=style&index=0&id=741421af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-741421af"]])

export default __exports__